import React, { Component } from "react";
import Typography from "material-ui-next/Typography";
import { StyledButton, Loadable } from "components/support";
import Dialog, { DialogTitle } from "material-ui-next/Dialog";
import Divider from "material-ui-next/Divider";
import { DialogContent, DialogActions } from "./dialog";
import IntegrationsList from "./integrations-list";

class Oms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: {
        organization_id: "",
        organization_name: "",
        stock_id: "",
        stock_name: "",
        sale_channel_id: "",
        sale_channel_name: "",
        token: ""
      },
      editing: false,
      uuid: ""
    };
  }

  render() {
    const { viewModel, presenter } = this.props;
    const {
      data,
      loading,
      errors,
      organizations,
      stocks,
      sale_channels,
      companyUuid
    } = viewModel;
    const title = `${!this.state.editing ? "Criar" : "Editar"} Integração`;

    const closeModal = () => {
      this.setState({ modal: false });
    };

    const openModal = () => {
      this.setState({ modal: true });
    };

    const handleEdit = formData => {
      this.setState({
        modal: true,
        editing: true,
        form: {
          organization_id: formData.organization_id,
          organization_name: formData.organization_name,
          stock_id: formData.stock_id,
          stock_name: formData.stock_name,
          sale_channel_id: formData.sale_channel_id,
          sale_channel_name: formData.sale_channel_name,
          token: formData.token
        },
        uuid: formData.uuid
      });
    };

    const handleSaveButtonClick = () => {
      presenter.onSave(
        this.state.form,
        this.state.editing,
        closeModal,
        this.state.uuid
      );
    };

    const changeForm = newState => {
      this.setState({
        form: {
          ...this.state.form,
          ...newState
        }
      });
    };

    return (
      <div style={{ padding: 20 }}>
        <Loadable loading={loading}>
          <Typography type="headline">Nexaas OMS</Typography>

          <Divider />

          <IntegrationsList
            integrations={data}
            presenter={presenter}
            handleEdit={handleEdit}
          />

          {data.length === 0 ? (
            <StyledButton
              primary
              label="Adicionar Integração"
              disabled={!companyUuid}
              onTouchTap={openModal}
              style={{
                marginTop: 20,
                pointerEvents: !companyUuid ? "none" : ""
              }}
            />
          ) : (
            ""
          )}

          <Dialog open={this.state.modal}>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent
              changeForm={changeForm}
              form={this.state.form}
              organizations={organizations}
              stocks={stocks}
              sale_channels={sale_channels}
              presenter={presenter}
              error={errors}
              editing={this.state.editing}
            />

            <DialogActions
              closeModal={closeModal}
              handleSaveButtonClick={handleSaveButtonClick}
              editing={this.state.editing}
            />
          </Dialog>
        </Loadable>
      </div>
    );
  }
}

export default Oms;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/oms/view.jsx